import { render, staticRenderFns } from "./CatchAll.vue?vue&type=template&id=fefcd6f2&"
import script from "./CatchAll.vue?vue&type=script&lang=js&"
export * from "./CatchAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports